import React, { useState, useMemo, useEffect } from "react";
import { TABLE_HEADER_INFO } from "./tableVariable";

const renderCustomHeader = (props) => {
    const HeaderValue = () => {
        if (props.header) {
            return props.header?.[props.type];
        } else {

        }
    };
    return (
        <>
            {props.data?.diffData?.[props.type] && <span className="for-diff block">{props.data.diffData?.[props.type]}</span>}
            {HeaderValue()}
        </>
    );
};

const CustomHeader = (props) => {
    const HeaderValue = useMemo(() => {
        return props.header?.[props.type];
    }, [props]);
    return (
        <>
            {props.data?.diffData?.[props.type] && <span className="for-diff block">{props.data.diffData?.[props.type]}</span>}
            {HeaderValue}
        </>
    );
};

const HideColumns = (e) => {
    const { target } = e;
    const table = target.closest("table");
    const isEdit = table.classList.contains("edit-table");
    const min = target.closest(".bpl-hide-columns").dataset.min;
    const max = target.closest(".bpl-hide-columns").dataset.max;
    const hided = table.querySelectorAll(`.sndsite`);
    const isHide = hided[0].classList.contains("hided");
    hided.forEach((e) => {
        e.classList.toggle("hided");
    });
    const colspaned = table.querySelectorAll("*[data-colspan]");
    colspaned.forEach((e) => {
        if (isHide) {
            e.colSpan = e.dataset.colspan;
        } else {
            e.colSpan = e.dataset.colspan - (max - min) - 1 - (isEdit ? 1 : 0);
        }
    });
    return !isHide;
};

const EyeDIV = (props) => {
    const [Hide, SetHide] = useState(false);
    return (
        <div className={"bpl-hide-columns"} onClick={(e) => SetHide(HideColumns(e))} data-min={props.min} data-max={props.max}>
            {/* <FontAwesomeIcon icon={Hide ? faEyeSlash : faEye} /> */}
            <div>{Hide ? "Show" : "Hide"}</div>
        </div>
    );
};

const in_table = [
    { name: "paraCd", type: "hidden", value: "", readOnly: true, required: true, type2: "hidden" },
    { name: "paraNm", type: "select", value: "", options: "main", required: true, type2: "hidden" , readyRequired : true },
    { name: "paraDesc", type: "text", value: "", required: true },
    {
        name: "unit",
        type: "select",
        value: "",
        options: "unit",
        style: { textAlign: "center" },
        required: true,
    },
    { name: "rcvCritical", type: "select", value: "", options: "critical", required: true },
    { name: "rcvSetpoint", type: "text", value: "" },
    {
        name: "rcvTarMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvTarMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvTarMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvTarMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAccMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAccMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMax", type: "text", value: "" },
    { name: "rcvCopy", type: "button", value: "", type2: "hidden" },
    { name: "sndCritical", type: "text", style: { textAlign: "center" },value: "" },
    { name: "sndSetpoint", type: "text", value: "" },
    {
        name: "sndTarMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndTarMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndTarMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndTarMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAcc1MinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAcc1Min", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAcc1MaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },

    { name: "sndAcc1Max", type: "text", value: "", style: { textAlign: "right" } },
    { name: "reference", type: "text", value: "" },
    { name: "remark", type: "checkbox", value: "FALSE" },
    { name: "hide", type: "hidden", value: "FALSE", maxLength: 1500, type2: "hidden" },
    { name: "uniqueCode", type: "hidden", type2: "hidden" },
    { name: "soSeq", type: "hidden", type2: "hidden" },
    { name: "paraSeq", type: "hidden", type2: "hidden" },
    { name: "interfaceCode", type: "hidden", type2: "hidden" },

];

const out_table = [
    { name: "paraCd", type: "hidden", value: "", readOnly: true, required: true, type2: "hidden" },
    {
        name: "testItem",
        type: "select",
        value: "",
        options: "main",
        required: true,
        type2: "hidden",
        readyRequired : true,
    },
    {
        name: "samplePoint",
        type: "hidden",
        value: "",
        options: "sample",
        label: "",
        type2: "hidden",
    },
    { name: "dayCycle", type: "hidden", value: "", maxLength: "2", type2: "hidden" },
    { name: "paraNm", type: "text", value: "", required: true },
    { name: "sopNo", type: "text", value: "",style: { textAlign: "center" }, required: true },
    {
        name: "unit",
        type: "select",
        value: "",
        options: "unit",
        style: { textAlign: "center" },
        required: true,
    },
    { name: "rcvCritical", type: "select", value: "", options: "critical", required: true },
    { name: "rcvSetpoint", type: "text", value: "" },
    {
        name: "rcvTarMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvTarMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvTarMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvTarMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAccMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAccMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMax", type: "text", value: "", style: { textAlign: "right" } },
    { name: "rcvCopy", type: "button", value: "", type2: "hidden" },
    { name: "sndCritical", type: "text", style: { textAlign: "center" },value: "" },
    { name: "sndSetpoint", type: "text", value: "" },
    {
        name: "sndTarMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndTarMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndTarMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndTarMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAcc1MinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAcc1Min", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAcc1MaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAcc1Max", type: "text", value: "", style: { textAlign: "right" } },
    { name: "reference", type: "text", value: "" },
    { name: "remark", type: "checkbox", value: "FALSE" },
    { name: "hide", type: "hidden", value: "FALSE", maxLength: 1500, type2: "hidden" },
    { name: "uniqueCode", type: "hidden", type2: "hidden" },
    { name: "soSeq", type: "hidden", type2: "hidden" },
    { name: "paraSeq", type: "hidden", type2: "hidden" },
    { name: "interfaceCode", type: "hidden", type2: "hidden" },
];

const qc_table = [
    { name: "paraCd", type: "hidden", value: "QC", required: true, type2: "hidden" },
    {
        name: "samplePoint",
        type: "hidden",
        value: "",
        options: "sample",
        label: "",
        type2: "hidden",
    },
    { name: "dayCycle", type: "hidden", value: "", maxLength: "2", type2: "hidden" },
    { name: "sampleDesc", type: "text", value: "", options: "qcGroup", required: true },
    { name: "paraNm", type: "text", value: "", required: true },
    { name: "testMethod", type: "text", value: "",style: { textAlign: "center" }, required: true },
    { name: "unit", type: "text", value: "", style: { textAlign: "center" }, required: true },
    { name: "rcvCritical", type: "select", value: "", options: "critical", required: true },
    {
        name: "rcvAlrMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvAlrMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAlrMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvAlrMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvActMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvActMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvActMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvActMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "rcvAccMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "min",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMin", type: "text", value: "" },
    {
        name: "rcvAccMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "max",
        style: { textAlign: "center" },
    },
    { name: "rcvAccMax", type: "text", value: "" },
    { name: "rcvCopy", type: "button", value: "", type2: "hidden" },
    { name: "sndCritical", type: "text", style: { textAlign: "center" },value: "" },
    {
        name: "sndAlrMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAlrMin", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAlrMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAlrMax", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAct1MinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAct1Min", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAct1MaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAct1Max", type: "text", value: "", style: { textAlign: "right" } },
    {
        name: "sndAccMinSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAccMin", type: "text", value: "" },
    {
        name: "sndAccMaxSign",
        type: "select",
        value: "",
        options: "sign",
        opttype: "all",
        style: { textAlign: "center" },
    },
    { name: "sndAccMax", type: "text", value: "" },
    { name: "optionCd", type: "select", value: "", options: "qcoption" },
    { name: "reference", type: "text", value: "" },
    { name: "remark", type: "checkbox", value: "FALSE" },
    { name: "hide", type: "hidden", value: "FALSE", maxLength: 1500, type2: "hidden" },
    { name: "uniqueCode", type: "hidden", type2: "hidden" },
    { name: "soSeq", type: "hidden", type2: "hidden" },
    { name: "paraSeq", type: "hidden", type2: "hidden" },
];

const composition_table = [
    { name: "paraCd", type: "hidden", value: "TBD", type2: "hidden" },
    { name: "materialCd", type: "text", value: "" },
    { name: "component", type: "text", value: "" },
    { name: "mainAlter", type: "select", value: "", options: "mainalter" },
    { name: "concentration", type: "text", value: "" },
    {
        name: "unit1",
        type: "text",
        value: "",
        style: { textAlign: "right" },
        borderStyle: { borderRight: "none" },
    },
    // { name: "unit1", type: "text", value: "", borderStyle: { borderRight: "none" } },
    { name: "unitseperator", type: "seperator", value: "/", borderStyle: { borderRight: "none" } },
    { name: "unit2", type: "text", value: "", borderStyle: { borderLeft: "none" },revCelNm :"unit1+unit2" },
    { name: "reference", type: "text", value: "" },
    { name: "remark", type: "checkbox", value: "FALSE" },
    { name: "uniqueCode", type: "hidden", type2: "hidden" },
    { name: "comSeq", type: "hidden", type2: "hidden" },
  ];

const all_table = [
    { id: "paraCd", name: "Parameter Code" },
    { id: "paraNm", name: "Parameter Type" },
    { id: "paraDesc", name: "Parameter Description" },
    { id: "unit", name: "Unit" },
    { id: "rcvCritical", name: "Receiving Site Criticality" },
    { id: "rcvSetpoint", name: "Receiving Site Set point" },
    { id: "rcvTarMinSign", name: "Receiving Site Target Range Min Sign" },
    { id: "rcvTarMin", name: "Receiving Site Target Range Min" },
    { id: "rcvTarMaxSign", name: "Receiving Site Target Range Max Sign" },
    { id: "rcvTarMax", name: "Receiving Site Target Range Max" },
    { id: "rcvAccMinSign", name: "Receiving Site Acceptable range Min Sign" },
    { id: "rcvAccMin", name: "Receiving Site Acceptable range Min" },
    { id: "rcvAccMaxSign", name: "Receiving Site Acceptable range Max Sign" },
    { id: "rcvAccMax", name: "Receiving Site Acceptable range Max" },
    { id: "rcvCopy", name: "" },
    { id: "sndCritical", name: "Sending Site Criticality" },
    { id: "sndSetpoint", name: "Sending Site Set Point" },
    { id: "sndTarMinSign", name: "Sending Site Target Range Min Sign" },
    { id: "sndTarMin", name: "Sending Site Target Range Min" },
    { id: "sndTarMaxSign", name: "Sending Site Target Range Max Sign" },
    { id: "sndTarMax", name: "Sending Site Target Range Max" },
    { id: "sndAcc1MinSign", name: "Sending Site Acceptable range Min Sign" },
    { id: "sndAcc1Min", name: "Sending Site Acceptable range Min" },
    { id: "sndAcc1MaxSign", name: "Sending Site Acceptable range Max Sign" },
    { id: "sndAcc1Max", name: "Sending Site Acceptable range Max" },
    { id: "reference", name: "Reference" },
    { id: "remark", name: "Remark" },
    { id: "hide", name: "" },
    { id: "uniqueCode", name: "" },
    { id: "testItem", name: "Test Item" },
    { id: "samplePoint", name: "Sample Point" },
    { id: "dayCycle", name: "Day/Cycle" },
    { id: "sopNo", name: "SOP No." },
    { id: "testMethod", name: "Test Method" },
    { id: "rcvAlrMinSign", name: "Receiving Site Alert Limit Min Sign" },
    { id: "rcvAlrMin", name: "Receiving Site Alert Limit Min" },
    { id: "rcvAlrMaxSign", name: "Receiving Site Alert Limit Max Sign" },
    { id: "rcvAlrMax", name: "Receiving Site Alert Limit Max" },
    { id: "rcvActMinSign", name: "Receiving Site Action Limit Min Sign" },
    { id: "rcvActMin", name: "Receiving Site Action Limit Min" },
    { id: "rcvActMaxSign", name: "Receiving Site Action Limit Max Sign" },
    { id: "rcvActMax", name: "Receiving Site Action Limit Max" },
    { id: "rcvAccSign", name: "Receiving Site Action Limit Acceptance Limit Sign" },
    { id: "rcvAcc", name: "Receiving Site Action Limit Acceptance Limit" },
    { id: "sndAlrMinSign", name: "Sending Site Alert Limit Min Sign " },
    { id: "sndAlrMin", name: "Sending Site Alert Limit Min " },
    { id: "sndAlrMaxSign", name: "Sending Site Alert Limit Max Sign " },
    { id: "sndAlrMax", name: "Sending Site Alert Limit Max " },
    { id: "sndAct1MinSign", name: "Sending Site Action Limit Min Sign " },
    { id: "sndAct1Min", name: "Sending Site Action Limit Min " },
    { id: "sndAct1MaxSign", name: "Sending Site Action Limit Max Sign " },
    { id: "sndAct1Max", name: "Sending Site Action Limit Max " },
    { id: "sndAccSign", name: "Sending Site Action Limit Acceptance Limit Sign " },
    { id: "sndAcc", name: "Sending Site Action Limit Acceptance Limit " },
    { id: "materialCd", name: "Material Code" },
    { id: "component", name: "Component" },
    { id: "mainAlter", name: "Main/Alter" },
    { id: "concentration", name: "Concentration" },
    { id: "unit1", name: "Unit" },
    { id: "unitseperator", name: "" },
    { id: "unit2", name: "Unit" },
    { id: "description", name: "Description" },
    { id: "cycle", name: "Cycle" },
    { id: "label", name: "Step Operation" },
    { id: "desc", name: "Description" },
    { id: "optionCd", name: "Option" },
];

const Header = {
    composition: (Header = null, show = false, data = {}, short = false, viewtable = false, number = true) => (
        <>
            <colgroup>
                {!short && (
                    <>
                        {number && <col width="25"></col>}

                        {/* Parameter Code */}
                       {/* <col width="70"></col>*/}
                    </>
                )}
                {/* Material Code */}
                <col width="50"></col>
                {/* Component */}
                <col width="120"></col>
                {/* Main / Alter */}
                <col width="70"></col>
                {/* Concentration */}
                <col width="150"></col>
                {/* Unit */}
                {viewtable ? (
                    <>
                        <col width="50"></col>
                    </>
                ) : (
                    <>
                        <col width="70"></col>
                        <col width="10"></col>
                        <col width="70"></col>
                    </>
                )}

                {/* Reference */}
                <col width="100"></col>
                {data?.edit && (
                    <>
                        {/* Remark */}
                        <col width="60"></col>
                        {/* Remove */}
                        <col width="15"></col>
                    </>
                )}
            </colgroup>
            <thead>
                <tr>
                    {!short && (
                        <>
                            {number && <th></th>}

                            {/*<th>Parameter Code</th>*/}
                        </>
                    )}

                    <th>Material Code</th>
                    <th>Component</th>
                    <th>Main/Alter</th>
                    <th>Concentration</th>
                    {viewtable ? <th>Unit</th> : <th colSpan="3">Unit</th>}

                    <th>Reference</th>
                    {data?.edit && (
                        <>
                            <th>Remark</th>
                        </>
                    )}
                </tr>
            </thead>
        </>
    ),
    in: (Header = null, show = false, data = {}, short = false, viewtable = false, number = true) => {
        return (
            <>
                <colgroup>
                    {!short && (
                        <>
                            {
                                number && <col width="25" />
                            }

                            {/* paracd */}
                            {/* <col width="70"></col> */}
                            {/* para type */}
                            <col></col>
                        </>
                    )}

                    {/* para desc */}
                    <col></col>
                    {/* unit */}
                    <col width="60"></col>
                    {/* rcv critical */}
                    <col width="60"></col>
                    {/* rcv setpoint */}
                    <col></col>
                    {viewtable ? (
                        <>
                            {/* rcv target  */}
                            <col width="50"></col>
                            <col width="50"></col>
                            {/* rcv acc */}
                            <col width="50"></col>
                            <col width="50"></col>
                        </>
                    ) : (
                        <>
                            {/* rcv target  */}
                            <col width="20"></col>
                            <col width="40"></col>
                            <col width="20"></col>
                            <col width="40"></col>
                            {/* rcv acc */}
                            <col width="20"></col>
                            <col width="40"></col>
                            <col width="20"></col>
                            <col width="40"></col>
                        </>
                    )}

                    {/* Copy Button */}
                    {data?.edit && <col className="sndsite" width="20"></col>}
                    {/* snd critical */}
                    <col className="sndsite" width="60"></col>
                    {/* snd setpoint */}
                    <col className="sndsite"></col>
                    {viewtable ? (
                        <>
                            {/* snd target  */}
                            <col className="sndsite" width="50"></col>
                            <col className="sndsite" width="50"></col>

                            {/* snd acc */}
                            <col className="sndsite" width="50"></col>
                            <col className="sndsite" width="50"></col>
                        </>
                    ) : (
                        <>
                            {/* snd target  */}
                            <col className="sndsite" width="20"></col>
                            <col className="sndsite" width="40"></col>
                            <col className="sndsite" width="20"></col>
                            <col className="sndsite" width="40"></col>
                            {/* snd acc */}
                            <col className="sndsite" width="20"></col>
                            <col className="sndsite" width="40"></col>
                            <col className="sndsite" width="20"></col>
                            <col className="sndsite" width="40"></col>
                        </>
                    )}

                    {/* reference */}
                    <col></col>
                    {data?.edit && (
                        <>
                            {/* remark */}
                            <col width="20"></col>
                            {/* hide */}
                            <col width="20"></col>
                            {/* Remove Button */}
                            <col width="15"></col>
                        </>
                    )}
                </colgroup>
                <thead>
                    <tr>
                        {!short && (
                            <>
                                {
                                    number && <th rowSpan="3"></th>
                                }

                                {/* <th rowSpan="3">Parameter Code</th> */}
                                <th rowSpan="3">Parameter Type</th>
                            </>
                        )}

                        <th rowSpan="3">Parameter Description</th>
                        <th rowSpan="3">Unit</th>
                        <th colSpan={viewtable ? "6" : "10"} style={{ position: "relative" }}>
                            {show && <EyeDIV min={16} max={25} />}
                            <CustomHeader type={"inReceivingSite"} header={Header} data={data} />
                        </th>
                        {data?.edit && <th className="sndsite" rowSpan="3"></th>}
                        <th className="sndsite" colSpan={viewtable ? "6" : "10"}>
                            <CustomHeader type={"inSendingSite"} header={Header} data={data} />
                        </th>
                        <th rowSpan="3">Reference</th>
                        {data?.edit && (
                            <>
                                <th rowSpan={"3"}>Remark</th>
                                <th rowSpan={"3"}>Hide</th>
                            </>
                        )}
                    </tr>

                    <tr>
                        <th rowSpan="2" style={{ borderLeft: "none" }}>
                            Criticality
                        </th>
                        <th rowSpan="2">Set point</th>
                        <th colSpan={viewtable ? "2" : "4"}>Target Range</th>
                        <th colSpan={viewtable ? "2" : "4"}>Acceptable range</th>
                        <th className="sndsite" rowSpan="2">
                            Criticality
                        </th>
                        <th className="sndsite" rowSpan="2">
                            <CustomHeader type={"inSetPoint"} header={Header} data={data} />
                        </th>
                        <th className="sndsite" colSpan={viewtable ? "2" : "4"}>
                            <CustomHeader type={"inTargetRange"} header={Header} data={data} />
                        </th>
                        <th className="sndsite" colSpan={viewtable ? "2" : "4"}>
                            <CustomHeader type={"inAcceptableRange"} header={Header} data={data} />
                        </th>
                    </tr>

                    {viewtable ? (
                        <tr>
                            <th>Min</th>
                            <th>Max</th>
                            <th>Min</th>
                            <th>Max</th>
                            <th className="sndsite">Min</th>
                            <th className="sndsite">Max</th>
                            <th className="sndsite">Min</th>
                            <th className="sndsite">Max</th>
                        </tr>
                    ) : (
                        <tr>
                            <th colSpan={"2"} style={{ borderLeft: "none" }}>
                                Min
                            </th>
                            <th colSpan={"2"}>Max</th>
                            <th colSpan={"2"}>Min</th>
                            <th colSpan={"2"}>Max</th>
                            <th className="sndsite" colSpan={"2"}>
                                Min
                            </th>
                            <th className="sndsite" colSpan={"2"}>
                                Max
                            </th>
                            <th className="sndsite" colSpan={"2"}>
                                Min
                            </th>
                            <th className="sndsite" colSpan={"2"}>
                                Max
                            </th>
                        </tr>
                    )}
                </thead>
            </>
        );
    },
    out: (Header, show = false, data = {}, short = false, viewtable = false, number = true) => (
        <>
            <colgroup>
                {!short && (
                    <>
                        {number && <col width="25" />}

                        {/* para code */}
                        {/* <col width="40" /> */}
                        {/* test item */}
                        <col width="200"/>
                        {/* sample pointe */}
                        {/*<col />*/}
                        {/* day / cycle */}
                        {/*<col width="45" />*/}
                    </>
                )}

                {/* paramter */}
                <col width="80"/>
                {/* sop no */}
                <col width="80"/>
                {/* unit */}
                <col width="60" />
                {/* rcv critical */}
                <col width="60"></col>
                {/* rcv setpoint */}
                <col width="60"></col>
                {viewtable ? (
                    <>
                        {/* rcv target */}
                        <col width="50"></col>
                        <col width="50"></col>

                        {/* rcv acc */}
                        <col width="50"></col>
                        <col width="50"></col>
                    </>
                ) : (
                    <>
                        {/* rcv target */}
                        <col width="20"></col>
                        <col width="40"></col>
                        <col width="20"></col>
                        <col width="40"></col>

                        {/* rcv acc */}
                        <col width="20"></col>
                        <col width="40"></col>
                        <col width="20"></col>
                        <col width="40"></col>
                    </>
                )}

                {/* Copy Button */}
                {data?.edit && <col className="sndsite" width="20"></col>}
                {/* snd critical */}
                <col className="sndsite" width="60"></col>
                {/* snd setpoint */}
                <col className="sndsite" width="60"></col>
                {viewtable ? (
                    <>
                        {/* snd target */}
                        <col width="50" className="sndsite"></col>
                        <col width="50" className="sndsite"></col>

                        {/* snd acc */}
                        <col width="50" className="sndsite"></col>
                        <col width="50" className="sndsite"></col>
                    </>
                ) : (
                    <>
                        {/* snd target */}
                        <col width="20" className="sndsite"></col>
                        <col width="40" className="sndsite"></col>
                        <col width="20" className="sndsite"></col>
                        <col width="40" className="sndsite"></col>

                        {/* snd acc */}
                        <col width="20" className="sndsite"></col>
                        <col width="40" className="sndsite"></col>
                        <col width="20" className="sndsite"></col>
                        <col width="40" className="sndsite"></col>
                    </>
                )}
                {/* reference */}
                <col width="130"/>
                {/* 
                  * munju 
                  * col width="200" 에서 130으로 수정  */}

                {data?.edit && (
                    <>
                        {/* remark */}
                        <col width="20"></col>
                        {/* hide */}
                        <col width="20"></col>
                        {/* Remove Button */}
                        <col width="15"></col>
                    </>
                )}
            </colgroup>
            <thead>
                <tr>
                    {!short && (
                        <>
                            {number && <th rowSpan="3"></th>}

                            {/* <th rowSpan="3">Parameter Code</th> */}
                            <th rowSpan="3">Test Item</th>
                            {/*<th rowSpan="3">Sample Point</th>
                            <th rowSpan="3">Day / Cycle</th>*/}
                        </>
                    )}
                    <th rowSpan="3">Parameter</th>
                    <th rowSpan="3">SOP No.</th>
                    <th rowSpan="3">Unit</th>
                    <th colSpan={viewtable ? "6" : "10"} style={{ position: "relative" }}>
                        {show && <EyeDIV min="17" max="26" />}
                        <CustomHeader type={"outReceivingSite"} header={Header} data={data} />
                    </th>
                    {data?.edit && <th className="sndsite" rowSpan="3"></th>}
                    <th className="sndsite" colSpan={viewtable ? "6" : "10"}>
                        <CustomHeader type={"outSendingSite"} header={Header} data={data} />
                    </th>
                    <th rowSpan="3">Reference</th>
                    {data?.edit && (
                        <>
                            <th rowSpan={"3"}>Remark</th>
                            <th rowSpan={"3"}>Hide</th>
                        </>
                    )}
                </tr>

                <tr>
                    <th rowSpan="2" style={{borderLeft: "none"}}>
                        Criticality
                    </th>
                    <th rowSpan="2">Set point</th>
                    <th colSpan={viewtable ? "2" : "4"}>Target Range</th>
                    <th colSpan={viewtable ? "2" : "4"}>Acceptable range</th>
                    <th className="sndsite" rowSpan="2">
                        Criticality
                    </th>
                    <th className="sndsite" rowSpan="2">Set point</th>
                    <th className="sndsite" colSpan={viewtable ? "2" : "4"}>
                        <CustomHeader type={"outTargetRange"} header={Header} data={data}/>
                    </th>
                    <th className="sndsite" colSpan={viewtable ? "2" : "4"}>
                        <CustomHeader type={"outAcceptableRange"} header={Header} data={data}/>
                    </th>
                </tr>
                {viewtable ? (
                    <tr>
                        <th>Min</th>
                        <th>Max</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th className="sndsite">Min</th>
                        <th className="sndsite">Max</th>
                        <th className="sndsite">Min</th>
                        <th className="sndsite">Max</th>
                    </tr>
                ) : (
                    <tr>
                        <th colSpan="2" style={{ borderLeft: "none" }}>
                            Min
                        </th>
                        <th colSpan="2">Max</th>
                        <th colSpan="2">Min</th>
                        <th colSpan="2">Max</th>
                        <th className="sndsite" colSpan="2">
                            Min
                        </th>
                        <th className="sndsite" colSpan="2">
                            Max
                        </th>
                        <th className="sndsite" colSpan="2">
                            Min
                        </th>
                        <th className="sndsite" colSpan="2">
                            Max
                        </th>
                    </tr>
                )}
            </thead>
        </>
    ),
    qc: (Header, show = false, data = {}, short = false, viewtable = false, number = true) => (
        <>
            <colgroup>
                {!short && (
                    <>
                        {number && <col width="25" />}
                        {/* para code */}
                        {/* <col width="40" /> */}
                        {/* sample point */}
                        {/*<col />*/}
                        {/* day cycle */}
                        {/*<col width="30" />*/}

                    </>
                )}
                {/* sample description */}
                <col width="60" />

                {
                    data?.diffData ? <>
                        {/* Test Item */}
                        <col width="80" />

                        {/* Method No. */}
                        <col width="60" />
                    </> : <>
                        {/* Test Item */}
                        <col width="80"/>

                        {/* Method No. */}
                        <col width="80"/>
                    </>
                }

                {/* unit */}
                <col width="60" />
                {/* rcv critical */}
                <col width="60" />
                {viewtable ? (
                    <>
                        {/* rcv alert */}
                        <col width="50" />
                        <col width="50" />

                        {/* rcv action */}
                        <col width="50" />
                        <col width="50" />

                        {/* rcv acc */}
                        <col width="50" />
                        <col width="50" />
                    </>
                ) : (
                    <>
                        {/* rcv alert */}
                        <col width="20" />
                        <col width="40" />
                        <col width="20" />
                        <col width="40" />
                        {/* rcv action */}
                        <col width="20" />
                        <col width="40" />
                        <col width="20" />
                        <col width="40" />
                        {/* rcv acc */}
                        <col width="20" />
                        <col width="40" />
                        <col width="20" />
                        <col width="40" />
                    </>
                )}

                {/* Copy Button */}
                {data?.edit && <col className="sndsite" width="20"></col>}
                {/* snd critical */}
                <col className="sndsite" width="60" />
                {viewtable ? (
                    <>
                        {/* snd alert */}
                        <col className="sndsite" width="50" />
                        <col className="sndsite" width="50" />

                        {/* snd action */}
                        <col className="sndsite" width="50" />
                        <col className="sndsite" width="50" />

                        {/* snd acc */}
                        <col className="sndsite" width="50" />
                        <col className="sndsite" width="50" />
                    </>
                ) : (
                    <>
                        {/* snd alert */}
                        <col className="sndsite" width="20" />
                        <col className="sndsite" width="40" />
                        <col className="sndsite" width="20" />
                        <col className="sndsite" width="40" />
                        {/* snd action */}
                        <col className="sndsite" width="20" />
                        <col className="sndsite" width="40" />
                        <col className="sndsite" width="20" />
                        <col className="sndsite" width="40" />
                        {/* snd acc */}
                        <col className="sndsite" width="20" />
                        <col className="sndsite" width="40" />
                        <col className="sndsite" width="20" />
                        <col className="sndsite" width="40" />
                    </>
                )}
                {!short && (
                    <>

                    </>
                )}
                {/* Options */}
                <col width="60" />

                {/* reference */}
                {
                    data?.diffData ? <col width="40" /> : <col width="200"/>
                }
                
                {data?.edit && (
                    <>
                        {/* remark */}
                        <col width="20"></col>
                        {/* hide */}
                        <col width="20"></col>
                        {/* Remove Button */}
                        <col width="20"></col>
                    </>
                )}
            </colgroup>
            <thead>
                <tr>
                    {!short && (
                        <>
                            {number && <th rowSpan="3"></th>}
                            {/* <th rowSpan="3">Parameter Code</th> */}
                            {/*<th rowSpan="3">Sample Point</th>
                            <th rowSpan="3">Day / Cycle</th>*/}

                        </>
                    )}
                    <th rowSpan="3" style={{fontSize: "0.6rem", padding: 0}}>Sample Description</th>
                    <th rowSpan="3">Test Item</th>

                    <th rowSpan="3">Method No.</th>
                    <th rowSpan="3">Unit</th>
                    <th colSpan={viewtable ? "7" : "13"} style={{ position: "relative" }}>
                        {show && <EyeDIV min="24" max="36" />}
                        <CustomHeader type={"qcReceivingSite"} header={Header} data={data} />
                    </th>
                    {data?.edit && <th className="sndsite" rowSpan="3"></th>}
                    <th className="sndsite" colSpan={viewtable ? "7" : "13"}>
                        <CustomHeader type={"qcSendingSite"} header={Header} data={data} />
                    </th>
                    {!short && (
                        <>
                            {/* <th rowSpan="3">Options</th> */}
                        </>
                    )}
                    <th rowSpan="3">Options</th>

                    <th rowSpan="5">Reference</th>
                    {data?.edit && (
                        <>
                            <th rowSpan={"3"}>Remark</th>
                            <th rowSpan={"3"}>Hide</th>
                        </>
                    )}
                </tr>

                <tr>
                    <th colSpan="1" rowSpan="2" style={{ borderLeft: "none" }}>
                        Criticality
                    </th>
                    <th colSpan={viewtable ? "2" : "4"}>Alert Limit</th>
                    <th colSpan={viewtable ? "2" : "4"}>Action Limit</th>
                    <th colSpan={viewtable ? "2" : "4"}>
                        Acceptance Limit
                    </th>
                    <th className="sndsite" rowSpan="2">
                        Criticality
                    </th>
                    <th className="sndsite" colSpan={viewtable ? "2" : "4"}>
                        <CustomHeader type={"qcAlertLimit"} header={Header} data={data} />
                    </th>
                    <th className="sndsite" colSpan={viewtable ? "2" : "4"}>
                        <CustomHeader type={"qcActionLimit"} header={Header} data={data} />
                    </th>
                    <th className="sndsite" colSpan={viewtable ? "2" : "4"}>
                        <CustomHeader type={"qcAcceptanceLimit"} header={Header} data={data} />
                    </th>
                </tr>
                {viewtable ? (
                    <tr>
                        <th>Min</th>
                        <th>Max</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th className="sndsite">Min</th>
                        <th className="sndsite">Max</th>
                        <th className="sndsite">Min</th>
                        <th className="sndsite">Max</th>
                        <th className="sndsite">Min</th>
                        <th className="sndsite">Max</th>
                    </tr>
                ) : (
                    <tr>
                        <th colSpan="2" style={{ borderLeft: "none" }}>
                            Min
                        </th>
                        <th colSpan="2">Max</th>
                        <th colSpan="2">Min</th>
                        <th colSpan="2">Max</th>
                        <th colSpan="2">Min</th>
                        <th colSpan="2">Max</th>
                        <th className="sndsite" colSpan="2">
                            Min
                        </th>
                        <th className="sndsite" colSpan="2">
                            Max
                        </th>
                        <th className="sndsite" colSpan="2">
                            Min
                        </th>
                        <th className="sndsite" colSpan="2">
                            Max
                        </th>
                        <th className="sndsite" colSpan="2">
                            Min
                        </th>
                        <th className="sndsite" colSpan="2">
                            Max
                        </th>
                    </tr>
                )}
            </thead>
        </>
    ),
};

const TABLE_DATA = {
    in: in_table,
    out: out_table,
    qc: qc_table,
    composition: composition_table,
    all: all_table,
    header: Header,
};

export default TABLE_DATA;
